import React, { FC } from 'react';
import { components as SelectComponents, OptionProps } from 'react-select';
import styled from 'styled-components';
import { IShipTo, ISoldTo } from '../../graphql/types';
import { Black1 } from '../../styles/colours';
import { DemiBold } from '../../styles/fonts';
import { CustomerType } from '../customer-type/customer-type';
import { ISelected } from './dropdown';

const StyledOption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
`;

const StyledMain = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTitle = styled.div`
  display: flex;
  flex-direction: row;

  font-family: ${DemiBold};

  width: 32rem;

  padding-bottom: 0.5rem;
`;

const StyledLabel = styled.div`
  margin-right: 0.5rem;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const StyledId = styled.div`
  margin-left: 0.5rem;
`;

const StyledAddress = styled.div`
  display: flex;
  flex-direction: row;
  color: ${Black1};
  font-size: 0.8rem;

  div + div {
    margin-left: 0.5rem;
  }
`;

const CompanyAddress: FC<{ customer: ISoldTo | IShipTo }> = ({ customer }) => {
  const { address, salesOrg } = customer;
  return (
    <StyledAddress>
      {address.street && <div title="Street">{address.street}</div>}
      {address.city && <div title="City">{address.city}</div>}
      {address.region && <div title="Region">{address.region}</div>}
      {address.postalCode && <div title="Post Code">{address.postalCode}</div>}
      {address.country && <div title="Country">{address.country}</div>}
      {salesOrg && <div title="Sales Org">{salesOrg}</div>}
    </StyledAddress>
  );
};

export const Option = (props: OptionProps<ISelected>) => {
  const { label, data } = props;
  const id = data.shipToId ? data.shipToId : data.soldToId;
  return (
    <SelectComponents.Option {...props}>
      <StyledOption data-type="option">
        <StyledMain>
          <StyledTitle>
            <StyledLabel data-type="option-label" data-value={label}>
              {label}
            </StyledLabel>
            -<StyledId data-type="option-id">{id}</StyledId>
          </StyledTitle>
          <CompanyAddress customer={data} />
        </StyledMain>
        <CustomerType type={data.type}>{data.type}</CustomerType>
      </StyledOption>
    </SelectComponents.Option>
  );
};
